import { gql } from '@apollo/client'

interface SendChatHistoryMutationVariables {
  caseId: string
}

interface SendChatHistoryMutationResponse {
  sendChatHistory: boolean
}

export const SEND_CHAT_HISTORY_MUTATION = gql`
  mutation sendChatHistory($caseId: ID!) {
    sendChatHistory(caseId: $caseId)
  }
`
export default SEND_CHAT_HISTORY_MUTATION

export type { SendChatHistoryMutationResponse, SendChatHistoryMutationVariables }
